import { ExportCategoryNodesRequest } from 'api/types/survey';
import { DataForSurveyController } from './ResultAnalysis';

export const buildExportRequest = (data: DataForSurveyController): ExportCategoryNodesRequest => ({
  categoryNodes: data.filters.map((filter) => ({
    id: filter.toString(),
  })),
  dates: data.dates,
});
